module.exports = __webpack_public_path__ + "components/patterns/paragraphTwoImagesWithTextFull/paragraph-two-images-with-text-full.tpl.php";